// extracted by mini-css-extract-plugin
export var markdown = "markdown-module--markdown--47iN9";